<template>
  <Accordion
      title="By Device"
      subtitle="What devices are being used?"
      :item-data="itemData"
  />
</template>

<script>

import Accordion from './Accordion.vue';

export default {
  name: 'AccordionDevices',
  components: {
    Accordion,
  },

  props: {
    itemData: {
      type: Array,
      default() {
        return ([]);
      },
    },
  },
};
</script>
